import { SVGProps } from 'react';

const BackIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      width="60"
      height="60"
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_133_1608)">
        <mask
          id="mask0_133_1608"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="14"
          y="14"
          width="32"
          height="32"
        >
          <path d="M46 14H14V46H46V14Z" fill="white" />
        </mask>
        <g mask="url(#mask0_133_1608)">
          <path
            d="M23.5 38.5L15 30L23.5 21.5"
            stroke="#3D3F42"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15 30H45"
            stroke="#3D3F42"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_133_1608">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(14 14)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default BackIcon;
